
import { RequestedValue$1 } from "../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../Communication.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray, singleton } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Storage_$reflection } from "../../Shared/Storage.js";
import { list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Location_$reflection } from "../../Shared/Location.js";
import { getAccountSettings } from "../../Requests/Customer.js";

export function init() {
    return [new State(new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, [])), Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Storage_$reflection())));
    })))), "/api/storages", (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(3, [Item_1]))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url_3), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_1) => {
        const pr_1 = response_1.arrayBuffer();
        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(Location_$reflection())));
    })))), "/api/locations", (Item_2) => (new Msg(0, [Item_2])), (Item_3) => (new Msg(3, [Item_3]))), getAccountSettings((Item_4) => (new Msg(1, [Item_4])), (Item_5) => (new Msg(3, [Item_5])))]))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 2:
            return [new State(new RequestedValue$1(1, [msg.fields[0]]), state.Locations, state.AccountSettings), Cmd_none()];
        case 1:
            return [new State(state.Storages, state.Locations, new RequestedValue$1(1, [msg.fields[0]])), Cmd_none()];
        case 3:
            return [state, Cmd_none()];
        default:
            return [new State(state.Storages, new RequestedValue$1(1, [msg.fields[0]]), state.AccountSettings), Cmd_none()];
    }
}

